module.exports = __webpack_public_path__ + "img/33.8301b7b4.svg";